import {
  GET_SYSTEM_AUDIT_REPORT_DATA,
  GET_SYSTEM_AUDIT_REPORT_DATA_START,
  GET_SYSTEM_AUDIT_REPORT_DATA_SUCCESS,
  GET_SYSTEM_AUDIT_REPORT_DATA_FAIL,
  GET_SYSTEM_AUDIT_REPORT_SEARCH_USERS,
  GET_SYSTEM_AUDIT_REPORT_SEARCH_USERS_START,
  GET_SYSTEM_AUDIT_REPORT_SEARCH_USERS_SUCCESS,
  GET_SYSTEM_AUDIT_REPORT_SEARCH_USERS_FAIL,
  SYSTEM_AUDIT_REPORT_ACTIVE_USERS_FILTERS,
  SYSTEM_AUDIT_REPORT_HYDRATE_ACTIVE_DYNAMIC_FILTERS,
  SYSTEM_AUDIT_REPORT_HYDRATE_ACTIVE_USERS,
  SYSTEM_AUDIT_REPORT_HYDRATE_ACTIVE_USERS_START,
  SYSTEM_AUDIT_REPORT_HYDRATE_ACTIVE_USERS_SUCCESS,
  SYSTEM_AUDIT_REPORT_HYDRATE_ACTIVE_USERS_FAIL,
  SYSTEM_AUDIT_REPORT_RESET_USERS_FILTERS,
} from 'actions/systemAuditReport';
import { v4 as uuidV4 } from 'uuid';

export const defaultState = {
  loading: false,
  error: false,
  data: [],
  total: 0,
  usersFilter: {
    data: [],
    total: 0,
    loading: false,
    activeItems: [],
  },
};

export default function systemAuditReport(state = defaultState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_SYSTEM_AUDIT_REPORT_DATA:
    case GET_SYSTEM_AUDIT_REPORT_DATA_START:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_SYSTEM_AUDIT_REPORT_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: payload.data.map(item => ({ uuid: uuidV4(), ...item })),
        total: payload.total,
      };
    case GET_SYSTEM_AUDIT_REPORT_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
      };
    case GET_SYSTEM_AUDIT_REPORT_SEARCH_USERS:
    case GET_SYSTEM_AUDIT_REPORT_SEARCH_USERS_START: {
      return {
        ...state,
        usersFilter: {
          ...state.usersFilter,
          loading: true,
        },
      };
    }
    case GET_SYSTEM_AUDIT_REPORT_SEARCH_USERS_SUCCESS: {
      const { data, total } = payload;
      return {
        ...state,
        usersFilter: {
          ...state.usersFilter,
          data,
          total,
          loading: false,
        },
      };
    }
    case GET_SYSTEM_AUDIT_REPORT_SEARCH_USERS_FAIL: {
      return {
        ...state,
        usersFilter: {
          ...state.usersFilter,
          loading: false,
        },
      };
    }
    case SYSTEM_AUDIT_REPORT_ACTIVE_USERS_FILTERS: {
      const activeItems = [
        ...state.usersFilter.activeItems,
        ...payload.filter(
          item => !state.usersFilter.activeItems.find(a => a.id === item.id),
        ),
      ];
      return {
        ...state,
        usersFilter: {
          ...state.usersFilter,
          activeItems,
        },
      };
    }
    case SYSTEM_AUDIT_REPORT_HYDRATE_ACTIVE_DYNAMIC_FILTERS: {
      const [storeKey] = Object.keys(action.payload);
      const value = action.payload[storeKey];
      const count = value.length;

      return {
        ...state,
        [storeKey]: {
          data: [...value],
          count,
          total: count,
          loading: false,
        },
      };
    }
    case SYSTEM_AUDIT_REPORT_HYDRATE_ACTIVE_USERS: {
      return state;
    }
    case SYSTEM_AUDIT_REPORT_HYDRATE_ACTIVE_USERS_START: {
      return {
        ...state,
        usersFilter: {
          ...state.usersFilter,
          loading: true,
        },
      };
    }
    case SYSTEM_AUDIT_REPORT_HYDRATE_ACTIVE_USERS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        usersFilter: {
          ...state.usersFilter,
          data,
          loading: false,
        },
      };
    }

    case SYSTEM_AUDIT_REPORT_HYDRATE_ACTIVE_USERS_FAIL: {
      return {
        ...state,
        usersFilter: {
          ...state.usersFilter,
          loading: false,
        },
      };
    }
    case SYSTEM_AUDIT_REPORT_RESET_USERS_FILTERS: {
      return {
        ...state,
        usersFilter: {
          ...state.usersFilter,
          data: [],
          total: 0,
          activeItems: payload,
        },
      };
    }
    default:
      return state;
  }
}
